import { Typography, TableCell } from '@mui/material';

const CellHeader: React.FC<{ title: string }> = ({ title }) => (
  <TableCell style={{ padding: '10px 10px 10px 0px', borderBottomColor: 'rgba(2, 15, 42, 0.20)' }}>
    <Typography variant="h5" color="rgba(38, 38, 38, 0.7)">
      {title}
    </Typography>
  </TableCell>
);

export default CellHeader;
